export default function Contact() {
  return (
    <section id="contact" className="bg-black text-white px-5 py-12">
      
      {/* Top label */}
      <div className="flex items-center gap-3 md:mb-8 mb-4">
        <h3 className="text-sm uppercase tracking-wide text-[#D07728] whitespace-nowrap">
          GET IN TOUCH
        </h3>
        <div className="h-px w-1/3 bg-[#D07728]/60" />
      </div>

      {/* Main content */}
      <div className="flex flex-col md:flex-row justify-between items-start md:gap-12 gap-6">
        
        {/* Left side */}
        <h2 className="text-4xl max-w-md">
          Let's Start a{" "}
          <span className="text-[#D07728]"><br/>Conversation</span>
        </h2>

        {/* Right side */}
        <div className="max-w-sm">
          <p className="text-gray-400 mb-2 md:text-lg">
            For speaking invitations, media enquiries, and academic collaboration:
          </p>

          <div className="flex flex-col gap-2">
            <a href="tel:+447842216810" className="hover:text-[#D07728] transition">
              +44 7842 216810
            </a>
            <a href="mailto:harvmins@icloud.com" className="hover:text-[#D07728] transition">
              harvmins@icloud.com
            </a>
          </div>
        </div>

      </div>
      <div className="mt-2 text-center text-gray-500 text-sm">
        &copy; {new Date().getFullYear()} Dr Harvey C. Kwiyani. All rights reserved.
        Made by <a href="https://mrandesign.com/" className="text-[#D07728] hover:underline ml-1" target="_blank" rel="noopener noreferrer">Mran Design</a>.
      </div>
    </section>
  );
}